const cohortFilterActions = {
  REMOVE_FILTER_FROM_COHORT: 'REMOVE_FILTER_FROM_COHORT',
  UPDATE_QUERY_FILTER_VALUES: 'UPDATE_QUERY_FILTER_VALUES',
  UPDATE_QUERY_FILTER_OPERATOR: 'UPDATE_QUERY_FILTER_OPERATOR',
  UPDATE_QUERY_FILTER_FIELD: 'UPDATE_QUERY_FILTER_FIELD',
  UPDATE_QUERY_FILTER_JOIN: 'UPDATE_QUERY_FILTER_JOIN',
  ADD_QUERY_FILTER: 'ADD_QUERY_FILTER',
};

export const cohortFilterWidths = {
  FIELD: 6,
  OPERATOR: 2,
  VALUES: 6,
};

const cohortGreatLessOperators = {
  GREATER_THAN: '>',
  GREATER_THAN_EQUALS: '>=',
  LESS_THAN: '<',
  LESS_THAN_EQUALS: '<=',
};

export const cohortArrayOperators = {
  IN: 'in',
  NOT_IN: 'not in',
};

export const cohortExistOperators = {
  EXISTS: 'not null',
  NOT_EXISTS: 'null',
};

export const cohortEqualsOperators = {
  EQUALS: '=',
  NOT_EQUALS: '!=',
};

export const cohortEqualsLikeOperators = {
  ...cohortEqualsOperators,
  LIKE: 'like',
};

export const cohortRangeOperators = {
  IN_RANGE: 'in range',
};

export const cohortJoinOperators = {
  INCLUDE: 'includes',
  EXCLUDE: 'excludes',
};

export const cohortGreatLessEqualsOperators = {
  ...cohortEqualsOperators,
  ...cohortGreatLessOperators,
};

export const cohortFilters = {
  boolean: {
    EQUALS: '=',
    ...cohortExistOperators,
  },
  date: {
    ...cohortGreatLessEqualsOperators,
    ...cohortExistOperators,
    ...cohortRangeOperators,
  },
  datetime: {
    ...cohortGreatLessEqualsOperators,
    ...cohortExistOperators,
    ...cohortRangeOperators,
  },
  decimal: {
    ...cohortGreatLessEqualsOperators,
    ...cohortExistOperators,
    ...cohortArrayOperators,
    ...cohortRangeOperators,
    ...cohortJoinOperators,
  },
  integer: {
    ...cohortGreatLessEqualsOperators,
    ...cohortExistOperators,
    ...cohortArrayOperators,
    ...cohortRangeOperators,
    ...cohortJoinOperators,
  },
  text: {
    ...cohortEqualsLikeOperators,
    ...cohortExistOperators,
    ...cohortArrayOperators,
    ...cohortJoinOperators,
  },
  time: {
    ...cohortGreatLessEqualsOperators,
    ...cohortExistOperators,
    ...cohortRangeOperators,
  },
};

export default cohortFilterActions;
